import Link from 'next/link'

import { Picture } from 'src/components/Picture'
import { ImageType } from 'src/components/Picture/Picture.types'
import { ImagesDirectory, generateImageUrl } from 'src/utils/setImageUrl'

import classes from './styles.module.scss'

type Props = {
  preview: {
    data: {
      promoUrl: string
      imageUrl: string
      imageAlt: string
      descriptionText: string
    }
  }
}

export default function PromoPreviewItem(props: Props) {
  const { preview } = props
  const promotionsUrl = generateImageUrl(preview.data.imageUrl, ImagesDirectory.PROMOTIONS)

  return (
    <div className={classes.previewItem} key={preview.data.promoUrl}>
      <Link href={preview.data.promoUrl} prefetch={false}>
        <Picture
          src={promotionsUrl}
          alt={preview.data.imageAlt}
          loading='lazy'
          type={ImageType.PROMOTIONS}
          className={classes.previewImage}
        />
      </Link>
      <div className={classes.contentWraper}>
        <p className={classes.previewText}>{preview.data.descriptionText}</p>
        <Link href={preview.data.promoUrl} className={classes.previewButton} prefetch={false}>
          learn more
        </Link>
      </div>
    </div>
  )
}
